import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { App } from "./pages";
import { StoreProvider } from "./components/providers/Store";

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
